import { render, staticRenderFns } from "./fixedAssetsList.vue?vue&type=template&id=818e1f78&scoped=true"
import script from "./fixedAssetsList.vue?vue&type=script&lang=js"
export * from "./fixedAssetsList.vue?vue&type=script&lang=js"
import style0 from "./fixedAssetsList.vue?vue&type=style&index=0&id=818e1f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818e1f78",
  null
  
)

export default component.exports